module.exports = __webpack_public_path__ + "static/media/43.03b072c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/43.png
// module id = 467
// module chunks = 0